import MyCollapse from "../../components/MyCollapse";

const AboutUs01 = () => {
  const content = [
    {
      value: 1,
      title: "CDH란 무엇인가요?",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text ac1-2">
            <div className="top">
              <span>
                <img
                  src="/assets/img/icon/01-01.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <div className="text">
                <p>
                  선천성 횡격막 탈장(Congenital Diaphragmatic Hernia, CDH)은
                  임신 중 발생하는 심각한 선천성 기형입니다. 태아가 뱃속에서
                  자라면서 가슴과 배를 구분하는 횡격막 (가로막)이 완전히 닫히지
                  않고 원래 배쪽에 있어야 하는 장기(위, 소장, 간 등)가 가슴으로
                  올라가서 생기는 질환입니다. 가슴 쪽으로 올라간 배 쪽 장기가
                  폐와 심장을 눌러 엄마 뱃속에서부터 폐가 정상적으로 자라지
                  못하는 것이 가장 큰 문제입니다. 간혹 심장 기능도 떨어져
                  있습니다.
                </p>
              </div>
            </div>
            <div className="img">
              <img src="/assets/img/ac1-2.png" alt="" />
            </div>
            <h6>[좌측 선천성 횡격막 탈장 예시]</h6>
          </div>
        </div>
      ),
    },
    {
      value: 2,
      title: "CDH는 얼마나 발생하나요?",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text ac1-2">
            <div className="top">
              <span>
                <img
                  src="/assets/img/icon/01-02.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <p>
                외국 보고에 따르면 신생아 약 4,000명 당 한 명 정도로 발생하는
                드문 질환입니다. 전 세계적으로는 연간 약 16,000명의 아기가 CDH를
                가지고 태어납니다. 현재 국내 출생아 수를 감안할 때 우리나라에는
                최근 매년 약 60명 정도 횡격막 탈장 아기가 태어날 것으로
                추정합니다.
              </p>
            </div>
          </div>
        </div>
      ),
    },
    {
      value: 3,
      title: "CDH는 왜 생기나요?",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text ac1-2" style={{ marginBottom: 15 }}>
            <div className="top">
              <span>
                <img
                  src="/assets/img/icon/01-03.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <p style={{ color: "#000" }}>
                CDH의 정확한 원인은 아직 완전히 밝혀지지 않았습니다. 다음과 같은
                요인들이 관련될 수 있습니다.
              </p>
            </div>
          </div>
          <div className="ac_text ac1-3">
            <dl>
              <dt>01</dt>
              <dd>
                <h2>유전적 요인</h2>
                <p>
                  대략 30% 정도는 특정 유전자 변이와 연관되어 있습니다. 유전적
                  이상은 다른 기형이 동반되는 경우 (증후군/복합 CDH)도 있고 다른
                  기형 없이 CDH만 발생하는 경우 (단독 CDH) 모두 가능합니다.
                  염색체 수 이상, 중복, 결실 등 다양한 유전자에 걸친 문제가
                  보고되어 있습니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>02</dt>
              <dd>
                <h2>환경적 요인</h2>
                <p>
                  임신 중 특정 약물 노출이나 비타민 A 결핍 등이 위험을
                  증가시킨다는 보고도 있으나 확실하지 않습니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>03</dt>
              <dd>
                <h2>복합적 요인</h2>
                <p>
                  대부분 유전적 요인과 환경적 요인이 복합적으로 작용하는 것으로
                  추정됩니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>04</dt>
              <dd>
                <h2>재발</h2>
                <p>
                  원인은 알려져 있지 않지만 2% 정도는 동생에게도 다시 생길 수
                  있다고 알려져 있습니다.
                </p>
              </dd>
            </dl>
          </div>
        </div>
      ),
    },
    {
      value: 4,
      title: "CDH는 어떻게 분류하나요?",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text ac1-2" style={{ marginBottom: 15 }}>
            <div className="top">
              <span>
                <img
                  src="/assets/img/icon/01-04.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <p style={{ color: "#000" }}>
                CDH는 주로 횡격막 결손부위의 위치에 따라 분류됩니다.
              </p>
            </div>
          </div>
          <div className="ac_text ac3-2">
            <dl>
              <dt>01</dt>
              <dd>
                <h2>좌측 CDH (좌측 Bochdalek 탈장)</h2>
                <p>가장 흔한 형태로 전체 사례의 약 80-85%를 차지합니다.</p>
              </dd>
            </dl>
            <dl>
              <dt>02</dt>
              <dd>
                <h2>우측 CDH (우측 Bochdalek 탈장)</h2>
                <p>비교적 드물며 약 10-15% 정도 발생합니다.</p>
              </dd>
            </dl>
            <dl>
              <dt>03</dt>
              <dd>
                <h2>양측성 CDH</h2>
                <p>매우 드물고 예후가 좋지 않습니다.</p>
              </dd>
            </dl>
            <dl>
              <dt>04</dt>
              <dd>
                <h2>중앙 CDH (Morgagni 탈장)</h2>
                <p>횡격막의 앞쪽 중앙부에 발생하며, 전체의 2% 미만입니다.</p>
              </dd>
            </dl>
            <div className="img">
              <img src="/assets/img/ac1-4.png" alt="" className="pc" />
              <img src="/assets/img/mac1-4.png" alt="" className="mob" />
            </div>
            <br />
            <h6>
              {
                "좌측 CDH는 결손의 크기에 따라 A < B < C < D로 구분하기도 합니다. 결손이 클수록 예후는 좋지 않습니다."
              }
            </h6>
          </div>
        </div>
      ),
    },
    {
      value: 5,
      title: "CDH의 치료 결과는 어떤가요?",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text ac1-2">
            <div className="top">
              <span>
                <img
                  src="/assets/img/icon/01-05.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <p>
                전세계 CDH 등록 레지스트리에 따르면 최근 20년간 ECMO 생존율은
                조금씩 향상되어 왔으며 평균 생존율은 25-30% 로 보고되고
                있습니다. 기존 국내 기관의 보고에서 CDH의 생존율은 약 70%
                정도였습니다. 그러나 ECMO가 가능한 6개 대학 병원으로 구성된
                선천성 횡격막 탈장 전향적 레지스트리 (K-CDH)의 초기 생존율은 약
                85%로 보고되었습니다. 사망과 관련된 아기의 위험인자로는 주요
                동반 기형, 낮은 폐 머리 비율, 미숙아 등이 있습니다. 또한 모든
                중증 질환이 그러하듯 환자의 상태 뿐 아니라 치료를 담당하는
                의료진의 경험과 치료 방법도 생존율을 결정하는 중요한 요인입니다.
              </p>
            </div>
          </div>
        </div>
      ),
    },
    {
      value: 6,
      title: "CDH의 사망 원인은 무엇인가요?",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text ac1-2" style={{ marginBottom: 15 }}>
            <div className="top">
              <span>
                <img
                  src="/assets/img/icon/01-06.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <p style={{ color: "#000" }}>
                CDH의 주요 사망 원인은 다음과 같습니다.
              </p>
            </div>
          </div>
          <div className="ac_text ac1-3">
            <dl>
              <dt>01</dt>
              <dd>
                <h2>폐 저형성</h2>
                <p>
                  CDH로 인해 폐가 제대로 발달하지 못해 호흡 기능이 심각하게
                  저하됩니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>02</dt>
              <dd>
                <h2>폐고혈압</h2>
                <p>
                  폐혈관이 제대로 발달하지 못해 혈액 순환에 문제가 생깁니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>03</dt>
              <dd>
                <h2>심장기능 저하</h2>
                <p>태아기부터 심장 기능이 감소되어 있는 경우가 발견됩니다.</p>
              </dd>
            </dl>
            <br />
            <h6>
              위의 세가지 문제는 산소 공급과 공기 교환에 문제를 일으켜 결국 주요
              장기의 기능을 저하시켜 사망에 이르게 합니다.
            </h6>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="acco">
      <MyCollapse data={content} />

      <div className="ac_text">
        <div className="info_text">
          <p>
            조기 진단과 적절한 치료를 통해 생존율을 높일 수 있으며, 의료 기술의
            발전으로 예후가 점차 개선되고 있습니다. 그러나 CDH는 여전히 심각한
            질환으로, 장기적인 의료적 관리와 지원이 필요합니다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs01;
